import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {GlobalConstants} from '../global-constants';
import {JobStatus} from "./monitoring.models";
import {Observable} from "rxjs";
import {Location} from "../tools/tools.models";
import {SortDirection} from "@angular/material/sort";
import * as moment from "moment";

@Injectable({
    providedIn: 'root'
})
export class MonitoringService {

    constructor(private http: HttpClient) {
    }

    getEtlJobStatus(): Observable<JobStatus> {
        return this.http.get<JobStatus>(`${GlobalConstants.apiURL}/job-status`);
    }


    runEtlJob(): Observable<any> {
        return this.http.get<any>(`${GlobalConstants.apiURL}/run-job`);
    }

    findAllLocations(): Observable<Array<Location>> {
        return this.http.get<Array<Location>>(`${GlobalConstants.apiURL}/locations`);
    }

    reconcileJournals(request: any[], synchronizeMappings, forceExtract): Observable<void> {
        return this.http.post<void>(
            `${GlobalConstants.apiURL}/api/reconciliation/recreateJournals?forceExtract=${forceExtract}&fetchMappings=${synchronizeMappings}`, request);
    }

    findJobHistory(sort: string, order: SortDirection, page: number, size: number, search) {
        const sortParameter = sort ? `&sort=${sort},${order}` : '';
        const searchParameter = search ? `&search=${search}` : '';
        return this.http.get(`${GlobalConstants.apiURL}/job-history/find?page=${page}&size=${size}${sortParameter}${searchParameter}`);
    }

    delete(id: number) {
        return this.http.delete(`${GlobalConstants.apiURL}/job-history/delete/${id}`);
    }
}
